import { Element, HTMLReactParserOptions } from "html-react-parser";
import { ReactNode } from "react";

export interface Replacer {
  supports(element: Element): boolean;
  replace(element: Element, options: HTMLReactParserOptions): ReactNode;
}

export function createReplacer(replacer: Replacer): Replacer {
  return {
    supports: replacer.supports,
    replace: replacer.replace,
  };
}
